import { render, staticRenderFns } from "./NovoBoletimSanitarioDialog.vue?vue&type=template&id=e7847b16&scoped=true&"
import script from "./NovoBoletimSanitarioDialog.vue?vue&type=script&lang=js&"
export * from "./NovoBoletimSanitarioDialog.vue?vue&type=script&lang=js&"
import style0 from "./NovoBoletimSanitarioDialog.vue?vue&type=style&index=0&id=e7847b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7847b16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VDialog,VDivider,VFlex,VIcon,VTextField})
